import React from 'react';
import PropTypes from 'prop-types';

import { Container, IDesc } from './common/styles';
import OptionsControl from './options-control';
import { updateNotifyOnMention } from '../../../services/profiles/notification-settings-service';

export default function MentionOptionsControl(props) {
  return (
    <Container>
      <IDesc>
        When someone mentions me in a wire
      </IDesc>
      <OptionsControl
        id="mention-options"
        options={props.options}
        updateOptionsFunction={updateNotifyOnMention}
      />
    </Container>
  );
}

MentionOptionsControl.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};
